export class FechaEstimadaEquivalencia {
    rangoInicial: number;
    rangoFinal: number;
    estimadoInicial: number;
    estimadoFinal: number;
}
